// extracted by mini-css-extract-plugin
module.exports = {"container":"TaskDetailPage_container__3qytV"};